export const PLOT_VALUES = {
  e: 'e',
  a: 'a'
}
